module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2v"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Ack"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Note1"
    }
  }, [_vm._v("Note on Translation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Abbrivations"
    }
  }, [_vm._v("List of Textual Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01"
    }
  }, [_vm._v("1 First Words")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Marking the Limits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 A Question of Inheritance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Nature of Nature")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Technological Language")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 A Homeric Inheritance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 What Words Will")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 The Tragedy of Cratylus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Comedy of the "), _c('em', [_vm._v("Cratylus")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b41fffc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Contents.vue
// module id = 75
// module chunks = 0